export default __webpack_public_path__ + "static/media/edit.a32dd35a.svg";